import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../../../layout/theme-next';
import { NextTheme } from '../../../../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  option: {
    fontSize: 14,
    overflowWrap: 'anywhere',
  },
  expired: {
    color: Colors.errorHighlight,
  },
  lotContainer: {
    display: 'flex',
    alignItems: 'center',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  icon: {
    fontSize: 16,
    cursor: 'pointer',
  },
}));
